import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AboutComp from '../../components/AboutComp/AboutComp';
import MediaPartners from '../../components/MediaPartners/MediaPartners';
import Jury from '../../components/Jury/Jury';
import FAQAccordion from "../../components/FAQAccordion/FAQAccordion";
import faqData from "../../config/faqdata";
import ScheduleAndPrizes from '../ScheduleAndPrizes/ScheduleAndPrizes';
import './Hero.css';
import { COMPETITION_END_DATE, WINNERS_ANNOUNCEMENT_DATE, breif_doc_name } from '../../config/config';
import axios from 'axios';

const Hero = () => {
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [isNewsletterPopupVisible, setNewsletterPopupVisible] = useState(true);
    const [isCompetitionOpen, setCompetitionOpen] = useState(true);
    const [isWinnersAnnounced, setWinnersAnnounced] = useState(false);
    const [email, setEmail] = useState('');
    const [subscriptionConfirmed, setSubscriptionConfirmed] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const currentDate = new Date();
        if (currentDate >= COMPETITION_END_DATE) {
            setCompetitionOpen(false);
        }
        if (currentDate >= WINNERS_ANNOUNCEMENT_DATE) {
            setWinnersAnnounced(true);
        }
    }, []);
    
    const handleButtonClick = () => {
        setPopupVisible(true);
    };

    const handleClosePopup = () => {
        setPopupVisible(false);
    };

    const handleDownload = () => {
  const fileUrl = `/docs/${breif_doc_name}.pdf`;

  // Detect if the user is on mobile
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    // On mobile, open in new tab (Safari/Chrome blocks programmatic download)
    window.open(fileUrl, '_blank');
  } else {
    // On desktop, trigger download normally
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = `${breif_doc_name}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};


    const handleRegisterClick = () => {
        navigate('/register');
    };

    const handleViewWinnersClick = () => {
        navigate('/winners');
    };

    const handleSubscribe = async (e) => {
        e.preventDefault();
    
        if (!email || !/\S+@\S+\.\S+/.test(email)) {
            alert('Please enter a valid email address!');
            return;
        }
    
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/newsletter/subscribe`, {
                email
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            console.log("Subscription response:", response);

            if (response?.data?.message?.toLowerCase().includes('success')) {
                setSubscriptionConfirmed(true);
                setEmail('');
            } else {
                alert('Something went wrong. Please try again.');
            }
        } catch (error) {
            console.error('Subscription error:', error);
            alert('Failed to subscribe. Please try again later.');
        }
    };
    
    return (
        <div className="App">
            <div className='hero'>
                <div className='hero-content'>
                    <div className="hero-text text-box">
                        <h1>Design with Curves: <br/>The Ultimate Fluidity Challenge <br/>(First Edition)</h1>
                        {isCompetitionOpen ? (
                            <>
                                <button className='hero-button' onClick={handleButtonClick}>Join Now</button>
                            </>
                        ) : isWinnersAnnounced ? (
                            <div className="competition-message">
                                <h2>Winners Announced!</h2>
                                {/* <p>The winners have been announced! Check out the winners page for more details.</p> */}
                                <button onClick={handleViewWinnersClick}>View Winners</button>
                            </div>
                        ) : (
                            <h2 className="competition-closed">Competition Closed</h2>
                        )}
                    </div>
                </div>
            </div>

            {isPopupVisible && (
                <div className="popup">
                    <div className="popup-content">
                        <button className="close-button" onClick={handleClosePopup}>✖</button>
                        <button className="popup-button" onClick={handleDownload}>Download Brief</button>
                        <button className="popup-button" onClick={handleRegisterClick}>Register/Sign In</button>
                    </div>
                </div>
            )}

{isNewsletterPopupVisible && (
    <div className="newsletter-popup">
        <div className="newsletter-popup-content">
            <button className="newsletter-close-button" onClick={() => setNewsletterPopupVisible(false)}>✖</button>
            {subscriptionConfirmed ? (
                <div className="thank-you-message">
                    <h2>Thank you for subscribing! 🎉</h2>
                    <p>We’ll keep you updated with the latest news and announcements.</p>
                </div>
            ) : (
                <>
                    <h2>Subscribe to Our Newsletter</h2>
                    <form onSubmit={handleSubscribe}>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                        />
                        <button type="submit">Subscribe</button>
                    </form>
                </>
            )}
        </div>
    </div>
)}


            <AboutComp />
            <ScheduleAndPrizes />
            <Jury />
            <MediaPartners />
            <section className="faq-section">
      <h2 className='faq-title'>FAQ</h2>
      <FAQAccordion faqs={faqData} />
    </section>
        </div>
    );
};

export default Hero;
